module.exports = __webpack_public_path__ + "img/upload.efbccf4abae6012a7807f96f5c46723a.efbccf4a.jpg";